export const educationStrings = {
    en: {
        educationTitle: "Education",
        educationSubtitle: "My Education",
        educationBachelorDegree: "System and Network Programming, Engineering",
        educationMasterDegree: "Databases and Software Engineering, Master of Science",
        educationSchool1: "Polish-Japanese Institute of Information Technology, Warsaw",
        educationBachelorDescription: "Diploma: SNMP protocol client (Java)",
        educationMasterDescription: "Diploma: Software configuration management system (PowerBuilder with Sybase database)",
    },
    pl: {
        educationTitle: "Wykształcenie",
        educationSubtitle: "Moje Wykształcenie",
        educationBachelorDegree: "Programowanie systemowe i sieciowe, inżynier",
        educationMasterDegree: "Bazy danych i inżynieria oprogramowania, magister",
        educationSchool1: "Polsko-Japońska Akademia Technik Komputerowych, Warszawa",
        educationBachelorDescription: "Dyplom: Klient protokołu SNMP (Java)",
        educationMasterDescription: "Dyplom: System zarządzania wersjami (PowerBuilder + baza danych Sybase)",
    },
};

export default educationStrings;
